export default "__VITE_ASSET__3f8b8b75__"